import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { CartProvider } from './contexts/CartContext';
import { WishlistProvider } from './contexts/WishlistContext';

function App() {
  const { i18n: i18nInstance } = useTranslation();

  useEffect(() => {
    // Set document direction based on language
    const isRTL = i18nInstance.language === 'fa';
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = i18nInstance.language;
  }, [i18nInstance.language]);

  return (
    <I18nextProvider i18n={i18n}>
      <CartProvider>
        <WishlistProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppRoutes />
          </BrowserRouter>
        </WishlistProvider>
      </CartProvider>
    </I18nextProvider>
  );
}

export default App;
